<template>
  <div class="baogao-jc-detail">
    <div class="baogao-detail-top">
      <img src="~@/assets/images/zhuyuan/zy-jc-bj.png" alt="">
    </div>
    <van-cell-group inset>
      <van-cell title="开方医生">
        <template #default>
          {{ info.empName }}
        </template>
      </van-cell>
      <van-cell title="开方科室">
        <template #default>
          {{ info.orgName }}
        </template>
      </van-cell>
      <van-cell title="报告时间">
        <template #default>
          {{ info.studyTime }}
        </template>
      </van-cell>
      <van-cell title="报告单号">
        <template #default>
          {{ info.pacsStudyuniqueid }}
        </template>
      </van-cell>
    </van-cell-group>
    <div class="list-box">
      <div class="list-wrap">
        <div class="list-item">检查项目</div>
        <div class="list-item">检查结果</div>
        <div class="list-item">诊断意见</div>
      </div>
      <div class="list-wrap list-wrap2">
        <div class="list-item">{{ info.studyscripTion }}</div>
        <div class="list-item">{{ info.reportDescribe }}</div>
        <div class="list-item">{{ info.reportDiagnose }}</div>
      </div>
      <van-button round type="info" class="download-btn" @click="downloadPdf">下载报告</van-button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BaoGaoDetail',
  data() {
    return {
      id: '',
      blhNo: '',
      list: [],
      info: {}
    }
  },
  created() {
    this.id = this.$route.query.id
    // this.getReportDetail()
    const baogaoJcDetail = localStorage.getItem('baogaoJcDetail')
    if (!baogaoJcDetail) return
    const info = JSON.parse(baogaoJcDetail)
    if (this.id !== info.pacsStudyuniqueid) return
    this.info = info
  },
  mounted() {},
  methods: {
    /* getReportDetail() {
      this.$Apis.getInspectReport({ blhNo: this.blhNo }).then(res => {
        console.log(res)
        this.info = res.data.find(item => item.id === this.id)
      })
    } */
    downloadPdf() {
      const downloadLink = document.createElement('a')
      const newDomain = 'https://www.szmshospital.com/pdf'
      const url = this.info.pdfUrl.replace(/^http[s]?:\/\/[^\/]+\/\/PDF/i, newDomain)
      downloadLink.href = url
      downloadLink.download = `${this.info.studyscripTion}_检查报告.pdf`
      document.body.appendChild(downloadLink)
      downloadLink.click()
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.baogao-jc-detail{
  min-height: calc(100vh - .2rem);
  padding-bottom: .2rem;
  .baogao-detail-top{
    padding: .1rem .15rem;
    min-height: 1.25rem;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .list-box{
    margin: .1rem .15rem 0;
    padding: .1rem;
    background: #fff;
  }
  .list-wrap{
    margin-top: .1rem;
    display: flex;
    border-top: 1px solid #E8EAED;
    border-bottom: 1px solid #E8EAED;
    .list-item{
      color: #2B8CFF;
      background: #F8F8F8;
      flex: 1;
      word-break: break-all;
      padding: .1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.5;
      border-left: 1px solid #E8EAED;
    }
    :last-child{
      border-right: 1px solid #E8EAED;
    }
  }
  .list-wrap2{
    margin: 0;
    border-top: none;
    .list-item{
      color: #555;
      background: #fff;
    }
  }
}

.download-btn{
  width: 100%;
  margin-top: 25px;
}
</style>
